import { Home, Menu, Search, Layers, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { cn } from '@/shared/lib/cn';
import { useShellStore } from '../model/shellStore';
import { useTabsStore } from '../tabs/tabsStore';

/** Telefon alt çubuğu: Ana sayfa · Menü · Ara · Sekmeler · Profil. */
export function BottomBar({ onTabs, onProfile }: { onTabs: () => void; onProfile: () => void }) {
  const { t } = useTranslation();
  const setDrawer = useShellStore((s) => s.setDrawer);
  const setSpotlight = useShellStore((s) => s.setSpotlight);
  const activeTabId = useTabsStore((s) => s.activeTabId);
  const activate = useTabsStore((s) => s.activate);
  const count = useTabsStore((s) => s.tabs.length);
  const navigate = useNavigate();
  const items = [
    {
      icon: Home,
      label: t('shell.home'),
      active: activeTabId === null,
      onClick: () => {
        activate(null);
        navigate('/', { replace: true });
      },
    },
    { icon: Menu, label: t('shell.menu'), active: false, onClick: () => setDrawer(true) },
    { icon: Search, label: t('shell.search'), active: false, onClick: () => setSpotlight(true) },
    { icon: Layers, label: t('shell.tabs'), active: activeTabId !== null, onClick: onTabs, badge: count },
    { icon: User, label: t('shell.profile'), active: false, onClick: onProfile },
  ];
  return (
    <nav className="border-border bg-bg-elevated sticky bottom-0 z-30 grid grid-cols-5 border-t pb-[env(safe-area-inset-bottom)]">
      {items.map((it) => (
        <button
          key={it.label}
          type="button"
          onClick={it.onClick}
          className={cn(
            'relative flex flex-col items-center gap-0.5 py-2 text-[11px]',
            it.active ? 'text-brand-600' : 'text-fg-muted',
          )}
        >
          <it.icon className="h-5 w-5" />
          {it.label}
          {it.badge ? (
            <span className="bg-brand-600 absolute top-1 right-4 rounded-full px-1.5 text-[10px] text-white">
              {it.badge}
            </span>
          ) : null}
        </button>
      ))}
    </nav>
  );
}
